<template>
  <div class="container" id="PROJECT-GET">
    <div class="common-title">
      <div class="common-title-content">
        项目落地
      </div>
    </div>
    <div class="grid">
      <div class="map">
        <img src="@/assets/images/aboutUs/map.png" />
        <div
          class="feature"
          :style="{ left: feature.position.left, top: feature.position.top }"
          v-for="(feature, index) in features"
          :key="index"
        >
          <div class="text">{{ feature.text }}</div>
        </div>
      </div>
      <div class="location">
        <div class="item" v-for="(item, idx) in items" :key="idx">
          <div class="line"></div>
          <ul>
            <li v-for="text in item.list" :key="text">{{ text }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "project",
  data() {
    return {
      features: [
        { text: "北京", position: { top: "20.95rem", left: "46.45rem" } },
        { text: "天津", position: { top: "21.55rem", left: "47.6rem" } },
        { text: "滨州", position: { top: "24.4rem", left: "48.65rem" } },
        { text: "青岛", position: { top: "24.4rem", left: "50.65rem" } },
        { text: "济宁", position: { top: "26.4rem", left: "47.65rem" } },
        { text: "盐城", position: { top: "28.2rem", left: "51.4rem" } },
        { text: "上海", position: { top: "31.4rem", left: "53.45rem" } },
        { text: "合肥", position: { top: "31.2rem", left: "48.6rem" } },
        { text: "鄂州", position: { top: "33.6rem", left: "46.75rem" } },
        { text: "武汉", position: { top: "33.1rem", left: "45.4rem" } },
        { text: "荆州", position: { top: "31.85rem", left: "44rem" } },
        { text: "荆门", position: { top: "33.6rem", left: "42.95rem" } },
        { text: "襄阳", position: { top: "31rem", left: "41.8rem" } },
        { text: "重庆", position: { top: "34.35rem", left: "37.35rem" } },
        { text: "西安", position: { top: "27.9rem", left: "39.6rem" } },
        { text: "成都", position: { top: "32.95rem", left: "33.4rem" } },
        { text: "厦门", position: { top: "39.85rem", left: "50.65rem" } },
        { text: "深圳", position: { top: "42.35rem", left: "47rem" } },
        { text: "广州", position: { top: "42.2rem", left: "44.55rem" } }
      ],
      items: [
        {
          list: ["北京市东城区东花市街道"]
        },
        {
          list: ["武汉市光谷理想城", "武汉市碧湖社区", "荆门市掇刀区双喜街道"]
        },
        {
          list: ["青岛市即墨区灵山街道", "养生谷社区"]
        },
        {
          list: ["广州市荔湾区中南街道", "深圳市光明区光明新村"]
        },
        {
          list: ["合肥市蜀山区南七街道", "合肥市蜀山区丁香花园"]
        },
        {
          list: ["......"]
        }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  background-color: #06070b;
  overflow: hidden;
  .common-title {
    .common-title-content {
      color: #ffffff;
    }
  }
  .grid {
    .map {
      position: relative;
      width: 69.65rem;
      height: 69.65rem;
      margin: 0 auto 1.8rem;
      img {
        width: 100%;
        height: 100%;
      }
      .feature {
        position: absolute;
        width: 0.948rem;
        height: 1.6rem;
        background-image: url("~@/assets/images/aboutUs/ico_feature.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        z-index: 99;
        transform: translate(0.25rem, 0.8rem);
        .text {
          position: absolute;
          bottom: -2rem;
          left: 50%;
          font-size: 0.9rem;
          color: #ffffff;
          transform: translate(-50%, -50%);
          z-index: 100;
          white-space: nowrap;
        }
        &:hover {
          animation: dump 1s ease 1;
        }
      }
    }
    .location {
      padding: 0 11.5rem 4.5rem;
      display: flex;
      justify-content: space-around;
      .item {
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        font-size: 0.9rem;
        color: #ffffff;
        text-align: center;
        .line {
          width: 2.8rem;
          // border: 1px solid #2f61ae;
          // height: 1px;
          // background-color: #2f61ae;
          height: 1px; /*no*/
          transform: scale(1, 1);
          // height: 1px;
          // background: #e6e6e6;
          // border: 1px solid #e6e6e6;
          background-color: #2f61ae;
        }
        ul {
          margin-top: 1rem;
          line-height: 1.8rem;
        }
      }
    }
  }
}

@keyframes dump {
  0% {
    transform: translate(0.25rem, 0.8rem);
  }
  50% {
    transform: translate(0.25rem, -50% + 0.8rem);
  }
  100% {
    transform: translate(0.25rem, 0.8rem);
  }
}
</style>
